'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var initialState = {};

exports.__exports = initialState;
